export const b2bSepaTranslations = {
  direct_debit_mandate: {
    get_data: {
      error: "Échec de l'obtention des données: %{error}",
    },
    sign: {
      error: "N'a pas réussi à signer le mandat: %{error}",
    },
  },
};
